import type { Dictionary } from './en';

/**
 * Indonesian (Bahasa Indonesia). Also served to Malay (`ms`) browsers — the two
 * are mutually intelligible for copy this short. ⚠️ Not natively reviewed.
 */
export const id: Dictionary = {
    'nav.find': 'Cari',
    'nav.prayer': 'Salat',
    'nav.cards': 'Kartu',
    'nav.saved': 'Tersimpan',
    'nav.main': 'Navigasi utama',
    'nav.skip': 'Lompat ke konten',

    'search.placeholder': 'Cari di {city}',
    'search.label': 'Cari tempat di {city}',
    'search.clear': 'Hapus pencarian',
    'search.matches': '{count} hasil',
    'search.matches_one': '{count} hasil',
    'city.choose': 'Pilih kota',
    'city.trust.certified': 'Bersertifikat',
    'city.trust.mixed': 'Sebagian bersertifikat',
    'city.trust.community': 'Dari komunitas',

    'filter.label': 'Saring hasil',
    'filter.eat': 'Makan',
    'filter.shop': 'Belanja',
    'filter.pray': 'Salat',
    'filter.certifiedOnly': 'Hanya bersertifikat',
    'filter.hideExpired': 'Sembunyikan kedaluwarsa',
    'filter.nearMe': 'Dalam 2 km',
    'filter.clear': 'Hapus',
    'filter.noneCertified': 'Tidak ada tempat bersertifikat di kota ini',
    'filter.noneExpired': 'Tidak ada sertifikat kedaluwarsa di sini',

    'results.count': '{count} tempat',
    'results.count_one': '{count} tempat',
    'results.nearestFirst': ', terdekat lebih dulu',
    'results.loading': 'Memuat {city}…',
    'results.error': '{city} tidak dapat dimuat. Periksa koneksi Anda lalu coba lagi.',
    'results.emptyTitle': 'Tidak ada yang cocok dengan filter itu.',
    'results.emptyBody': 'Coba hapus satu filter, atau cari nama atau area lain.',
    'results.clearAll': 'Hapus semua filter',
    'results.heading': 'Tempat halal di {city}',

    'banner.community': 'Belum bersertifikat.',
    'banner.communityBody':
        '{count} tempat ini berasal dari {source}. Belum ada lembaga sertifikasi halal yang memeriksanya — tanyakan kepada staf sebelum memesan.',
    'banner.certified': '{certified} dari {total} memiliki sertifikat yang masih berlaku',
    'banner.certifiedBody': ' dari {source}.',
    'banner.lapsed': ' {count} sudah kedaluwarsa dan ditandai demikian.',
    'banner.lapsed_other': ' {count} sudah kedaluwarsa dan ditandai demikian.',
    'banner.mixedTail': ' Sisanya berasal dari komunitas dan belum bersertifikat.',
    'banner.checked': 'Diperiksa ke {source} {when}.',

    'assurance.certified': 'Bersertifikat halal',
    'assurance.certified.short': 'Bersertifikat',
    'assurance.certified.detail': 'Tempat ini memegang sertifikat halal dari lembaga sertifikasi yang diakui.',
    'assurance.certified_kitchen': 'Dapur halal bersertifikat',
    'assurance.certified_kitchen.short': 'Dapur bersertifikat',
    'assurance.certified_kitchen.detail': 'Dapur halal khusus dan bersertifikat di dalam tempat yang juga menyajikan makanan non-halal.',
    'assurance.muslim_friendly': 'Ramah muslim',
    'assurance.muslim_friendly.short': 'Ramah muslim',
    'assurance.muslim_friendly.detail': 'Bersertifikat tanpa babi dan alkohol, tetapi bukan tempat yang sepenuhnya halal.',
    'assurance.muslim_owned': 'Milik muslim',
    'assurance.muslim_owned.short': 'Milik muslim',
    'assurance.muslim_owned.detail': 'Dimiliki muslim, tanpa sertifikat dari pihak ketiga.',
    'assurance.self_declared': 'Halal menurut pengakuan sendiri',
    'assurance.self_declared.short': 'Pengakuan sendiri',
    'assurance.self_declared.detail': 'Tempat ini menyatakan menyajikan makanan halal. Belum ada lembaga yang memeriksanya.',
    'assurance.community_reported': 'Dilaporkan komunitas',
    'assurance.community_reported.short': 'Komunitas',
    'assurance.community_reported.detail':
        'Dipetakan oleh kontributor OpenStreetMap. Belum ada lembaga yang menyertifikasi — tanyakan kepada staf sebelum memesan.',

    'cert.label': 'Sertifikat halal',
    'cert.current': 'Sertifikat berlaku',
    'cert.expiring_soon': 'Segera berakhir',
    'cert.expired': 'Sertifikat kedaluwarsa',
    'cert.renewal_pending': 'Sedang diperpanjang',
    'cert.listed': 'Terdaftar bersertifikat',
    'cert.delisted': 'Dihapus dari daftar',
    'cert.unknown': 'Status tidak diketahui',
    'cert.reference': 'Nomor',
    'cert.category': 'Kategori',
    'cert.validUntil': 'Berlaku hingga',
    'cert.expiredOn': 'Kedaluwarsa',
    'cert.confirmed': 'Dikonfirmasi',
    'cert.noEndDate': 'tanpa tanggal berakhir',
    'cert.noCertifier': 'Lembaga tidak tercatat',
    'cert.expiredNote': 'Sertifikat ini sudah kedaluwarsa. Mungkin sudah diperpanjang — tanyakan ke tempatnya sebelum memesan.',
    'cert.delistedNote': 'Tempat ini tidak lagi ada di daftar {certifier}. Anggap belum bersertifikat.',
    'cert.pendingNote': 'Daftar mencatat sertifikat ini sedang diperpanjang.',
    'cert.openEndedNote':
        'Lembaga ini tidak menerbitkan tanggal berakhir. Sebuah tempat tetap terdaftar sampai sertifikatnya dicabut.',
    'cert.ariaValid': 'Berlaku hingga {date}',
    'cert.ariaExpired': 'Kedaluwarsa pada {date}',
    'cert.ariaOpen': 'Tidak ada tanggal berakhir yang diterbitkan. Dikonfirmasi {when}.',

    'place.back': 'Kembali ke daftar',
    'place.save': 'Simpan',
    'place.saved': 'Tersimpan',
    'place.address': 'Alamat',
    'place.hours': 'Jam buka',
    'place.phone': 'Telepon',
    'place.directions': 'Rute',
    'place.website': 'Situs web',
    'place.share': 'Bagikan',
    'place.listedBy': 'Terdaftar oleh {source}',
    'place.checkedWhen': 'Sertifikat diperiksa {when}',
    'place.approximate': 'Lokasi perkiraan — ditandai di {district} karena alamatnya tidak dapat dipetakan ke bangunan tertentu.',
    'place.theDistrict': 'distrik ini',
    'place.away': '{distance} dari sini',

    'type.restaurant': 'Restoran',
    'type.cafe': 'Kafe',
    'type.bakery': 'Toko roti',
    'type.fast_food': 'Makanan cepat saji',
    'type.food_court': 'Pujasera',
    'type.hotel_restaurant': 'Restoran hotel',
    'type.grocery': 'Toko bahan makanan',
    'type.butcher': 'Tukang daging',
    'type.mosque': 'Masjid',
    'type.prayer_room': 'Musala',
    'type.attraction_dining': 'Restoran tempat wisata',

    'prayer.title': 'Salat',
    'prayer.needLocation': 'Izinkan akses lokasi untuk mendapatkan jadwal salat dan arah kiblat di tempat Anda.',
    'prayer.next': 'Berikutnya',
    'prayer.fajr': 'Subuh',
    'prayer.sunrise': 'Terbit',
    'prayer.dhuhr': 'Zuhur',
    'prayer.asr': 'Asar',
    'prayer.maghrib': 'Magrib',
    'prayer.isha': 'Isya',
    'prayer.inHours': '{hours} jam {minutes} menit lagi',
    'prayer.inMinutes': '{minutes} menit lagi',
    'prayer.imminent': 'kurang dari semenit lagi',
    'prayer.highLatitude':
        'Pada lintang ini matahari tidak cukup turun di bawah ufuk hari ini untuk menghitung Subuh dan Isya secara konvensional. Ikuti jadwal masjid setempat.',
    'prayer.method': 'Metode perhitungan',
    'prayer.methodLabel': 'Metode',
    'prayer.asrLabel': 'Asar',
    'prayer.asrStandard': 'Standar (Syafi’i, Maliki, Hanbali)',
    'prayer.asrHanafi': 'Hanafi',
    'prayer.calcNote':
        'Dihitung di perangkat Anda dari lokasi Anda, jadi tetap jalan tanpa internet. Jadwal ini panduan — ikuti masjid setempat bila berbeda.',

    'qibla.title': 'Kiblat',
    'qibla.fromNorth': 'dari utara',
    'qibla.aria': 'Kiblat berada {degrees} derajat dari utara sejati',
    'qibla.needsPermission': 'Perangkat ini perlu izin sebelum dapat berfungsi sebagai kompas.',
    'qibla.usecompass': 'Gunakan kompas perangkat',
    'qibla.noCompass': 'Tidak ada pembacaan kompas di sini. Hadapkan ke {degrees}° dari utara sejati memakai kompas.',

    'cards.title': 'Tunjukkan ini kepada staf',
    'cards.type': 'Jenis kartu',
    'cards.language': 'Bahasa',
    'cards.halal': 'Halal',
    'cards.vegetarian': 'Vegetarian',
    'cards.allergies': 'Alergi',
    'cards.hint': 'Naikkan kecerahan layar lalu serahkan ponselnya.',

    'saved.title': 'Tersimpan',
    'saved.emptyTitle': 'Belum ada yang disimpan.',
    'saved.emptyBody': 'Ketuk penanda pada tempat mana pun untuk menyimpannya di sini — tetap tersedia tanpa internet.',
    'saved.emptyCta': 'Cari tempat makan',
    'saved.staleOne': '{count} tempat tersimpan memiliki sertifikat yang tidak lagi berlaku.',
    'saved.staleOther': '{count} tempat tersimpan memiliki sertifikat yang tidak lagi berlaku.',
    'saved.staleBody': ' Sertifikat bisa kedaluwarsa setelah disimpan — periksa sebelum berangkat.',
    'saved.remove': 'Hapus {name} dari tersimpan',

    'lang.choose': 'Pilih bahasa',
    'lang.label': 'Bahasa',

    'time.today': 'hari ini',
    'time.yesterday': 'kemarin',
    'time.daysAgo': '{count} hari lalu',
    'time.on': 'pada {date}',
};
